import THREE from 'three';
import {Shader} from '../../types/shader.types';

/*

  Minimal custom ShaderPass

 */
export class ShaderPass<SpecifiedShader extends Shader> {
  renderer: THREE.WebGLRenderer;
  shader: SpecifiedShader;
  shaderMat: THREE.RawShaderMaterial;
  orthoScene: THREE.Scene;
  orthoCamera: THREE.OrthographicCamera;
  orthoQuad: THREE.Mesh;
  fbo: THREE.WebGLRenderTarget;
  constructor(renderer: THREE.WebGLRenderer, shader: SpecifiedShader) {
    this.renderer = renderer;
    this.shader = shader;
    this.shaderMat = new THREE.RawShaderMaterial(shader);

    this.orthoScene = new THREE.Scene();
    const width = 1024;
    const height = 1024;
    this.fbo = new THREE.WebGLRenderTarget(width, height);
    this.orthoCamera = new THREE.OrthographicCamera(
      width / -2,
      width / 2,
      height / 2,
      height / -2,
      0.00001,
      1000
    );
    this.orthoQuad = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 1),
      this.shaderMat
    );
    this.orthoQuad.scale.set(width, height, 1);
    this.orthoScene.add(this.orthoQuad);
  }

  render(final = false, renderFBO = this.fbo): void {
    this.renderer.setRenderTarget(final ? null : renderFBO);
    this.renderer.render(this.orthoScene, this.orthoCamera);
  }

  setSize(width: number, height: number): void {
    this.fbo.setSize(width, height);
    this.orthoQuad.scale.set(width, height, 1);
    this.orthoCamera.left = -width / 2;
    this.orthoCamera.right = width / 2;
    this.orthoCamera.top = height / 2;
    this.orthoCamera.bottom = -height / 2;
    this.orthoCamera.updateProjectionMatrix();
  }
}
